import { render, staticRenderFns } from "./DistrictDelete.vue?vue&type=template&id=19f08f14&scoped=true&"
import script from "./DistrictDelete.vue?vue&type=script&lang=js&"
export * from "./DistrictDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f08f14",
  null
  
)

export default component.exports